<template>
  <transition name="stagger"
              @enter="enter"
              @leave="leave"
              @enter-cancelled="enterCancelled"
              @leave-cancelled="leaveCancelled"
              @after-leave="complete"
              @after-enter="complete">
    <slot />
  </transition>
</template>


<script>
import { TweenMax, TimelineMax, Expo } from 'gsap';

export default {
  name: 'TransitionStagger',
  css: false,

  methods: {
    enter: function (el, done) {
      if (this.tl) {
        this.tl.play();
      } else {
        this.tl = new TimelineMax({
          onComplete: done,
          onReverseComplete: done,
        });
        const animationElements = [...el.querySelectorAll('.js-transition--stagger')].reverse();
        this.tl.add(TweenMax.staggerFromTo(animationElements, 0.15, { opacity: 0, y: 10 }, { opacity: 1, y: 0, ease: Expo.easeOut }, 0.05));
      }
    },
    enterCancelled: function (el) {
    },
    leave: function (el, done) {
      this.tl.eventCallback('onReverseComplete', done);
      this.tl.reverse();
    },
    leaveCancelled: function (el) {
    },
    complete: function () {
      this.$emit('complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/transitions/TransitionStagger.vue